import axios from 'axios';
import {
  CommentaryTypeLabel,
  CommentaryFormat,
} from '../../../../commentary/commentary.types';

export type GetCommentaryResponse = {
  author: string;
  dateHtml: string;
  format: CommentaryFormat;
  sourceName: string;
  title: string;
  url: string;
} & (
  | { typeLabel: CommentaryTypeLabel.HYBRID }
  | { typeLabel: CommentaryTypeLabel.OPEN }
  | { typeLabel: CommentaryTypeLabel.PAPER }
);

export function getCommentariesLinkedToLegislation(
  docId: string,
  query: string,
): Promise<{ data: Array<GetCommentaryResponse> }> {
  return axios.get('/getCommentariesLinkedToLegislation', {
    params: {
      docId,
      query,
    },
  });
}
